import { useEffect, useState } from 'react';
import { useDownloadProgramArtifacts } from '@interxfi/api-client/program/download-program-artifacts';
import { useProgramMetaAccessSelector } from '@interxfi/api-client/program/program-auth-access-selector';

export function useProgramArtifact(programId: string | undefined, artifactId: string | undefined, skip?: boolean) {
  const programMetaAccess = useProgramMetaAccessSelector(programId);
  const [file, setFile] = useState<{ artifactId: string; file: string; name?: string; description?: string } | undefined>();
  const downloadProgramArtifacts = useDownloadProgramArtifacts(programMetaAccess);

  useEffect(() => {
    async function download() {
      try {
        if (programId && artifactId && !skip) {
          const res = await downloadProgramArtifacts({ programId, artifactIds: [artifactId] });

          if (res) {
            // There should only be one but just in case.
            const artifactMatch = res.artifacts?.find((artifact) => artifact.artifactId === artifactId);

            if (artifactMatch) {
              setFile(artifactMatch);
            } else {
              setFile(undefined);
            }
          }
        } else {
          setFile(undefined);
        }
      } catch {}
    }

    void download();
  }, [programId, artifactId, skip, downloadProgramArtifacts]);

  return file;
}
